import CantileverButton from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import { X } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

import { TermsContent } from './TermsContent'

const ModalOverlay = styled.div<{ $requiredToAccept: boolean }>`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${({ $requiredToAccept }) =>
    $requiredToAccept ? 'black' : 'rgba(0, 0, 0, 0.5);'};
  justify-content: center;
  align-items: center;
  z-index: 10000000;
  height: 100vh;
`

const ModalContent = styled.div`
  width: 50%;
  height: 80%;
  border-radius: 0.5rem;
`

const AcceptButton = styled(CantileverButton)`
  width: 100%;
`

interface TermsModalProps {
  requiredToAccept: boolean
  onAccept: () => void
  onClose: () => void
}

export const TermsModal: React.FC<TermsModalProps> = ({
  requiredToAccept,
  onAccept,
  onClose,
}) => {
  return (
    <ModalOverlay $requiredToAccept={requiredToAccept}>
      <ModalContent>
        <CantileverCard>
          <CantileverCard.CardHeader
            sticky
            leadingContent='Cantilever Terms of Service'
            trailingContent={
              !requiredToAccept && (
                <CantileverButton ghost iconOnly onClick={onClose}>
                  <X size={20} />
                </CantileverButton>
              )
            }
            subContent={
              requiredToAccept
                ? 'You must accept the terms to continue.'
                : undefined
            }
          />
          <CantileverCard.Section
            bottomBorder
            style={{
              height: '70vh',
              overflowY: 'auto',
            }}>
            <TermsContent />
          </CantileverCard.Section>
          {requiredToAccept && (
            <CantileverCard.Section topPadding bottomPadding>
              <AcceptButton primary onClick={onAccept}>
                Accept Terms
              </AcceptButton>
            </CantileverCard.Section>
          )}
        </CantileverCard>
      </ModalContent>
    </ModalOverlay>
  )
}
